import React from 'react';
import { ItemAllIconsComponent } from '../../ItemAllIcons';
import ItemWithTooltip from './ItemWithTooltip';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

export default function AllIconsItem({ item, isSimple, isExpanded }: Props) {
  return (
    <ItemWithTooltip item={item}>
      <ItemAllIconsComponent />
    </ItemWithTooltip>
  );
}
